import React from "react";
import { Button } from "../components/ui/button";
import { BRAND } from "../mock";

export default function Hero({ onStart }) {
  return (
    <section
      className="relative w-full min-h-[88vh] flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `url(${BRAND.hero.bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 hero-overlay" />
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center text-white py-24">
        <h1 className="font-display text-5xl md:text-7xl lg:text-8xl font-extrabold leading-[1.05] tracking-tight">
          {BRAND.hero.title}{" "}
          <span className="text-paul-yellow">{BRAND.hero.accent}</span>
          <br />
          <span className="accent-underline">{BRAND.hero.suffix}</span>
        </h1>
        <p className="mt-8 text-lg md:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed font-medium">
          {BRAND.hero.subtitle}
        </p>
        <div className="mt-10">
          <Button
            onClick={onStart}
            className="bg-paul-yellow hover:bg-paul-yellow text-navy font-bold px-10 py-6 text-base rounded-md shadow-lg hover:shadow-xl transition-shadow"
            style={{ color: "#0b1535" }}
          >
            {BRAND.hero.cta}
          </Button>
        </div>
      </div>
    </section>
  );
}
